import { Brand } from '@aura/contextos-frontend/dist/contexts/config/config.types';

export type FaseMuralAvisosModo = 'SEGMENTADO' | 'TODOS';

export enum ModalidadePeriodo {
  FLEX = 'FLEX',
  EAD = 'EAD',
  AO_VIVO = 'AO VIVO',
  PRESENCIAL = 'PRESENCIAL',
  SEMI = 'SEMI',
}

export enum TipoCurso {
  GRADUACAO_TECNOLOGICA = 'GRADUAÇÃO TECNOLÓGICA',
  GRADUACAO = 'GRADUAÇÃO',
  ESPECIALIZACAO = 'ESPECIALIZAÇÃO',
  TECNICO = 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO',
}

export interface SegmentacaoMuralAvisos {
  marcas: Brand[];
  tipoCurso: string[];
  modalidade: string[];
  periodo: string[];
  codigoCurso: string[];
}

export interface FaseMuralAvisos {
  fase: 1 | 2 | 3 | 4;
  habilitarAPartirDe: string;
  modo: FaseMuralAvisosModo;
  segmentacoes?: SegmentacaoMuralAvisos[];
}

export interface ElegibilidadeMuralAvisos {
  fases: FaseMuralAvisos[];
}
